/**
 * Reviews Tabs Section JavaScript
 * Handles tab switching, mobile sliders, and before/after image sliders
 */

document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.reviews-tabs');
  
  sections.forEach(section => {
    initializeReviewsTabs(section);
  });
});

function initializeReviewsTabs(section) {
  // Tab switching
  const tabs = section.querySelectorAll('.reviews-tabs__tab');
  const tabContents = section.querySelectorAll('.reviews-tabs__tab-content');
  
  // Mobile slider state for each tab
  const mobileSliders = new Map();
  
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const targetTab = this.dataset.tab;
      
      // Update tab states
      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      
      // Update content visibility
      tabContents.forEach(content => {
        if (content.dataset.tab === targetTab) {
          content.classList.remove('hidden');
          content.classList.add('visible');
          
          // Reset mobile slider for this tab
          if (window.innerWidth < 990) {
            const slider = mobileSliders.get(targetTab);
            if (slider) {
              slider.goToSlide(0);
            }
          }
        } else {
          content.classList.add('hidden');
          content.classList.remove('visible');
        }
      });
    });
  });
  
  // Reusable slider initialization function
  function initializeSlider(container, sliderName) {
    const sliderTrack = container.querySelector('[data-slider-track]');
    const prevBtn = container.querySelector('[data-nav="prev"]');
    const nextBtn = container.querySelector('[data-nav="next"]');
    const slides = container.querySelectorAll('.reviews-tabs__slide');
    
    if (sliderTrack && slides.length > 0) {
      let currentSlide = 0;
      const totalSlides = slides.length;
      
      const slider = {
        goToSlide: function(index) {
          currentSlide = Math.max(0, Math.min(totalSlides - 1, index));
          const translateX = -(currentSlide * 100);
          sliderTrack.style.transform = `translateX(${translateX}%)`;
          
          // Update button states
          if (prevBtn) prevBtn.disabled = currentSlide === 0;
          if (nextBtn) nextBtn.disabled = currentSlide === totalSlides - 1;
          
          // Update button active states
          if (prevBtn) {
            if (currentSlide === 0) {
              prevBtn.classList.remove('active');
            } else {
              prevBtn.classList.add('active');
            }
          }
          if (nextBtn) {
            if (currentSlide === totalSlides - 1) {
              nextBtn.classList.remove('active');
            } else {
              nextBtn.classList.add('active');
            }
          }
        },
        
        next: function() {
          if (currentSlide < totalSlides - 1) {
            this.goToSlide(currentSlide + 1);
          }
        },
        
        prev: function() {
          if (currentSlide > 0) {
            this.goToSlide(currentSlide - 1);
          }
        }
      };
      
      // Event listeners for navigation buttons
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          slider.prev();
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          slider.next();
        });
      }
      
      // Initialize first slide
      slider.goToSlide(0);
      
      // Store slider instance
      mobileSliders.set(sliderName, slider);
      
      return slider;
    }
    return null;
  }
  
  // Initialize mobile sliders for "show all blocks" mode
  const allBlocksSlider = section.querySelector('.reviews-tabs__slider-container:not(.reviews-tabs__content .reviews-tabs__slider-container)');
  if (allBlocksSlider) {
    initializeSlider(allBlocksSlider, 'all-blocks');
  }
  
  // Initialize mobile sliders for each tab
  tabContents.forEach(tabContent => {
    const tabName = tabContent.dataset.tab;
    const sliderContainer = tabContent.querySelector('.reviews-tabs__slider-container');
    
    if (sliderContainer) {
      initializeSlider(sliderContainer, tabName);
    }
  });
  
  // Before/After slider functionality
  const beforeAfterSliders = section.querySelectorAll('[data-before-after-slider]');
  
  beforeAfterSliders.forEach(slider => {
    const after = slider.querySelector('.reviews-tabs__after');
    const sliderHandle = slider.querySelector('.reviews-tabs__slider-handle');
    const sliderLine = slider.querySelector('.reviews-tabs__slider');
    
    let isDragging = false;
    let currentPercentage = 50;
    
    // Initialize at 50%
    updatePosition(50);
    
    // Mouse events
    slider.addEventListener('mousedown', startDrag);
    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', stopDrag);
    
    // Touch events for mobile
    slider.addEventListener('touchstart', startDrag, { passive: false });
    document.addEventListener('touchmove', drag, { passive: false });
    document.addEventListener('touchend', stopDrag);
    
    function updatePosition(percentage) {
      const clampedPercentage = Math.max(0, Math.min(100, percentage));
      currentPercentage = clampedPercentage;
      
      // Position both elements using percentage
      sliderHandle.style.left = clampedPercentage + '%';
      sliderLine.style.left = clampedPercentage + '%';
      after.style.clipPath = `polygon(${clampedPercentage}% 0, 100% 0, 100% 100%, ${clampedPercentage}% 100%)`;
    }
    
    function startDrag(e) {
      isDragging = true;
      slider.style.cursor = 'grabbing';
      updatePositionFromEvent(e);
      e.preventDefault();
    }
    
    function drag(e) {
      if (!isDragging) return;
      updatePositionFromEvent(e);
      e.preventDefault();
    }
    
    function updatePositionFromEvent(e) {
      const rect = slider.getBoundingClientRect();
      let clientX;
      
      if (e.type.includes('touch')) {
        clientX = e.touches[0].clientX;
      } else {
        clientX = e.clientX;
      }
      
      const x = clientX - rect.left;
      const percentage = (x / rect.width) * 100;
      updatePosition(percentage);
    }
    
    function stopDrag() {
      isDragging = false;
      slider.style.cursor = 'grab';
    }
  });
  
  // Handle window resize
  window.addEventListener('resize', function() {
    // Reset all sliders on resize
    mobileSliders.forEach(slider => {
      slider.goToSlide(0);
    });
  });
}
